import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {Constants} from './constants';

export function canWritePriceSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (
    permission &&
    permission.price_setting &&
    permission.price_setting === 3
  ) {
    return true;
  }

  return false;
}

export function canWritePlatformSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (
    permission &&
    permission.platform_setting &&
    permission.platform_setting === 3
  ) {
    return true;
  }

  return false;
}

export function canWriteAffiliateSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.affiliate && permission.affiliate === 3) {
    return true;
  }

  return false;
}

export function canWriteUserSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.user_setting && permission.user_setting === 3) {
    return true;
  }

  return false;
}

export function canWriteCMS() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.cms && permission.cms === 3) {
    return true;
  }

  return false;
}

export function canWriteWallet() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.wallet && permission.wallet === 3) {
    return true;
  }

  return false;
}

export function shouldShowDashboard() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.dashboard && permission.dashboard !== 0) {
    return true;
  }

  return false;
}

export function shouldShowRoundProfit() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.round_profit && permission.round_profit !== 0) {
    return true;
  }

  return false;
}

export function shouldShowPriceSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (
    permission &&
    permission.price_setting &&
    permission.price_setting !== 0
  ) {
    return true;
  }

  return false;
}

export function shouldShowPlatformSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (
    permission &&
    permission.platform_setting &&
    permission.platform_setting !== 0
  ) {
    return true;
  }

  return false;
}

export function shouldShowAffiliateSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.affiliate && permission.affiliate !== 0) {
    return true;
  }

  return false;
}

export function shouldShowUserSettings() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.user_setting && permission.user_setting !== 0) {
    return true;
  }

  return false;
}

export function shouldShowCMS() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.cms && permission.cms !== 0) {
    return true;
  }

  return false;
}

export function shouldShowWallet() {
  const permission = JSON.parse(localStorage.getItem('permission') || '{}');
  if (permission && permission.wallet && permission.wallet !== 0) {
    return true;
  }

  return false;
}

function getStartUrl() {
  const current = location.href;
  const urlSplit = current.split('/');

  return urlSplit.slice(3).join('/');
}

export function checkAccessibility(route: string) {
  if(getStartUrl().startsWith('app/cms/detail')) {
    return true;
  }
  if (Constants.PERMISSION_CONSTANT.hasOwnProperty(route)) {
    const page = Constants.PERMISSION_CONSTANT[route];
    const permission = JSON.parse(localStorage.getItem('permission') || '{}');
    if (permission && permission[page]) {
      return permission[page] !== 0;
    }
    return false;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadDashboard implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowDashboard();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadRoundProfit implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowRoundProfit();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadPriceSettings implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowPriceSettings();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadPlatformSettings implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowPlatformSettings();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadAffiliateSettings implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowAffiliateSettings();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadUserSettings implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowUserSettings();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadCMS implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowCMS();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ShouldLoadWallet implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return shouldShowWallet();
  }
}

@Injectable({
  providedIn: 'root'
})
export class CheckAccessibility implements CanActivate {
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return checkAccessibility(state.url);
  }
}
